import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';

import { defaultAxios } from '..';

const savedTopicService = {
  async createSavedTopic(params: CreateSavedTopicPayload) {
    const res = await defaultAxios.post<Topic2T<TOPIC_2_TYPE.SAVED_TOPIC>>(
      `/searches/${params.search_alias}/topic`,
      {
        title: params.title,
        desc: params.desc,
      },
    );
    return res.data;
  },
};

export default savedTopicService;
